module.exports = __webpack_public_path__ + "static/media/ICON_FB.98b8d6da.svg";